import { EMPTY_FIELD_TEXT, formatDetailDate } from "../detail-format/detail-format";
import {
  DETAIL_SECTION_EMPTY_CONTENT,
  DETAIL_SECTION_LOADING_MESSAGE,
  LAST_UPDATE_PREFIX,
} from "./detail-section.constants";
import type { DetailSectionProps } from "./types-detail-section";

const NOOP = () => undefined;

/**
 * Casca comum das seções do detalhamento: título, data de atualização, divisória e, no lugar do corpo, o estado da
 * consulta (carregando, vazio, erro, sem acesso). A seção só preenche o corpo e informa a situação.
 */
export function useDetailSection({
  id,
  title,
  ultimaAtualizacao,
  testId,
  status = "success",
  loadingMessage = DETAIL_SECTION_LOADING_MESSAGE,
  errorMessage = null,
  emptyContent = DETAIL_SECTION_EMPTY_CONTENT,
  onReauthenticate = NOOP,
  onRetry = NOOP,
}: Omit<DetailSectionProps, "children">) {
  const ultimaAtualizacaoTexto =
    ultimaAtualizacao === undefined
      ? null
      : `${LAST_UPDATE_PREFIX}: ${
          ultimaAtualizacao === null ? EMPTY_FIELD_TEXT : formatDetailDate(ultimaAtualizacao)
        }`;

  return {
    id,
    title,
    testId,
    headingId: `${id}-titulo`,
    ultimaAtualizacaoTexto,
    ultimaAtualizacaoTestId: `${testId}-ultima-atualizacao`,
    estado:
      status === "success"
        ? null
        : {
            status,
            loadingMessage,
            errorMessage,
            emptyContent,
            onReauthenticate,
            onRetry,
            testId,
          },
  };
}
